module.exports = __webpack_public_path__ + "img/badge-highest-revenue-keyvue-pink.34c55c2f.png";